import { render, staticRenderFns } from "./AiVoicePtHistory.vue?vue&type=template&id=1e5619da&scoped=true"
import script from "./AiVoicePtHistory.vue?vue&type=script&lang=js"
export * from "./AiVoicePtHistory.vue?vue&type=script&lang=js"
import style0 from "./AiVoicePtHistory.vue?vue&type=style&index=0&id=1e5619da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5619da",
  null
  
)

export default component.exports